<template>
  <transition name="fade">
    <div
      v-if="isShow"
      class="dialog">
      <div class="dialog__overlay"/>
      <div class="dialog__body">
        <a
          href="#"
          class="dialog__close"
          @click.prevent="onClose">
          <icon-close v-if="hasClose"/>
        </a>
        <slot/>
      </div>
    </div>
  </transition>
</template>

<script>
import IconClose from '@/mikan/_shared/components/atoms/icons/IconClose.vue';

export default {
  components: {
    IconClose,
  },
  model: {
    prop: 'isShow',
    event: 'input',
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    hasClose: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClose() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.2s ease;
}

.fade-enter-to {
  opacity: 1;
}

.fade-leave {
  opacity: 1;
}

.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-leave-to {
  opacity: 0;
}

.dialog {
  $root: &;

  position: fixed;
  z-index: 9999;
  top: 15%;
  left: 0;
  overflow: auto;
  width: 100%;
  height: 80%;

  &__body {
    position: relative;
    top: 50%;
    left: 50%;
    box-sizing: border-box;
    background-color: $color-white;
    border-radius: 4px;
    transform: translate(-50%, -50%);

    @include for-pc {
      width: 50%;
      max-width: 800px;
      padding: 40px 60px;
    }
    @include for-tb {
      width: 70%;
      max-width: 800px;
      padding: 20px;
    }
    @include for-sp {
      width: 80%;
      padding: 20px;
    }
  }

  &__close {
    position: absolute;
    right: 0;
    color: $color-white;
    font-size: 20px;
    font-weight: bold;
    @include for-tb-pc {
      top: -34px;
    }
    @include for-sp {
      top: -32px;
    }
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $color-black;
    opacity: 0.7;
  }
}
</style>
